import { render, staticRenderFns } from "./FeaturedPostListing.vue?vue&type=template&id=74781f40&scoped=true"
import script from "./FeaturedPostListing.vue?vue&type=script&lang=js"
export * from "./FeaturedPostListing.vue?vue&type=script&lang=js"
import style0 from "./FeaturedPostListing.vue?vue&type=style&index=0&id=74781f40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74781f40",
  null
  
)

export default component.exports